"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_TO_ROWS = void 0;
var SIZE_TO_ROWS = {
  sm: 2,
  md: 6,
  lg: 8
};
exports.SIZE_TO_ROWS = SIZE_TO_ROWS;